import React from "react";
import {withNamespaces} from "react-i18next";
import CheckboxColumn from "../../../../components/CheckboxColumn";
import HilightTable from "../../../../components/HilightTable";
import {Button, Spinner} from "react-bootstrap";
import DeviceGroupActionButtons from "./DeviceGroupActionButtons";
import {connect} from "react-redux";
import {claimTypes} from "../../../../constants/claim.constants";

const DeviceGroupTable = ({list, t, user, eventOnChangeOrder, eventOnChangeDefault}) => {

    const deviceGroupCrudPermission = user[`c_device-group.actions.crud`];

    const columns = [
        {
            Header: 'order',
            headerClassName: "wrapok",
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            show: deviceGroupCrudPermission === claimTypes.READ_WRITE,
            Cell: (props) => {
                const data = props.row.original;
                return (
                    <React.Fragment>
                        <Button
                            variant={"dark"}
                            disabled={data.order === 0}
                            onClick={() => eventOnChangeOrder('moveUp', data.id)}
                        >
                            <i className="fas fa-angle-up"> </i>
                        </Button>
                        &nbsp;
                        <Button
                            variant={"dark"}
                            disabled={data.order === (list.length - 1)}
                            onClick={() => eventOnChangeOrder('moveDown', data.id)}
                        >
                            <i className="fas fa-angle-down"> </i>
                        </Button>
                    </React.Fragment>
                )
            }
        },
        {
            Header: 'label',
            accessor: 'label'
        },
        {
            Header: 'is-default',
            accessor: 'isDefault',
            headerClassName: "text-center wrapok",
            classNameRow: 'text-center',
            styleRow: { width: '1px' },
            Cell: (props) => {
                const data = props.row.original;
                return (
                    <CheckboxColumn dataValue={data.isDefault} disabled={true}/>
                )
            }
        },
        {
            Header: 'actions',
            headerClassName: "text-right",
            classNameRow: 'text-right',
            styleRow: { width: '1px' },
            Cell: (props) => {
                const data = props.row.original;
                return (
                    <DeviceGroupActionButtons row={data} />
                );
            }
        }
    ];

    const tableResult = (
        list ?
            list.length === 0 ? (
                <div className="text-center p-4">
                    <h3>{ t('device-group-no-content')  }</h3>
                </div>
            ) : (
                <HilightTable
                    columns={columns}
                    data={list}
                />
            ) : (
                <React.Fragment>
                    <Spinner animation={"border"} />
                    <p>Loading ...</p>
                </React.Fragment>
            )
    );

    return (
        <div className="col-md-12 mx-0 my-3 p-0">
            { tableResult }
        </div>
    )
};
const mapStateToProps = (state) => {
    const { user } = state.authenticationReducer;
    return {user}
};
export default withNamespaces()(connect(mapStateToProps)(DeviceGroupTable));
